const imageData = {
  1: {
    title: '白羊座',
    image:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/9d32b5b891d04ec7c909df8b36b00c14.png',
    icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c0847335c6d6a678960f087cb8896c21.png'
  },
  2: {
    title: '金牛座',
    image:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0bab0bd51b0f2dfc4d1785d65fc39e0c.png',
    icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/5ee1bd723e8987fe5874d1563ed5cd71.png'
  },
  3: {
    title: '双子座',
    image:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0a68dca11dd8e5cd349021852ad728a9.png',
    icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/46651541d051c2d19903bfec5975dd7d.png'
  },
  4: {
    title: '巨蟹座',
    image:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/719e07d7d5fa03a3cfd9b86dbe7b906c.png',
    icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/01c01b7c3b1d722614468f93e4a9e882.png'
  },
  5: {
    title: '狮子座',
    image:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/2db3d3942ae4cddb6883ec45727ced49.png',
    icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f90ad7a6c8905812e264fe85b9cb7386.png'
  },
  6: {
    title: '处女座',
    image:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/432bab62d7c8880fa121fdfbdf6b4d34.png',
    icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d19759c2025f44977dbc46c8d4949c9a.png'
  },
  7: {
    title: '天秤座',
    image:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8be58da3914c4de8a38e592b5c7753cd.png',
    icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/42a02c4c3bb1211d679d66c56f345dc4.png'
  },
  8: {
    title: '天蝎座',
    image:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/5d082d54c998131092802300c2873f4e.png',
    icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/885bae49873a48a4599fbaa3e3b23935.png'
  },
  9: {
    title: '射手座',
    image:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/9d0765130077bd26b2aa37016c2ff894.png',
    icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c491bd61d5d732b4f2eca2f6bea778d0.png'
  },
  10: {
    title: '摩羯座',
    image:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/eb70e232f7960ffed3bf80c039fb62b0.png',
    icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/50305a8f71eb4d663e38345ac7bd1cd2.png'
  },
  11: {
    title: '水瓶座',
    image:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/fa2b7e118b1b9fe360c05d74d0471410.png',
    icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c3bf52544a9f7db2ca03d684bb9d5700.png'
  },
  12: {
    title: '双鱼座',
    image:
      'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/dd97e7b59c507bda8f3811f6e52b3eac.png',
    icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/edf50de8ef6898b7a166963bfffdcb39.png'
  }
}
export { imageData }
